import ExpandLessIcon from "@mui/icons-material/ExpandLess"
import { TableBody, TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material"
import React, { useEffect, useState } from "react"
import { Col, Form, InputGroup, Row } from "react-bootstrap"
import toast from "react-hot-toast"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import Constant from "../../../../../constant"
import Buttonaction from "../../../../components/Buttonaction"
import CurrencyInput from "../../../../components/CurrencyInput"
import MuiDataTable from "../../../../components/MuiDataTable"
import NegotiationOfferService from "../../../../services/NegotiationOfferService"
import Formservice from "../../../../services/Formservice"

const UnitPrice = (params) => {
   const {
      itemInitialPrice,
      negotiation,
      negotiationItems,
      socketRefNegotiation,
      fromAccountId,
      toAccountId,
      lastOffer,
      accountId,
      dataProcurement,
      vendorLastPrice,
   } = params

   const dispatch = useDispatch()
   const [offerPayloads, setOfferPayloads] = useState([])
   const [disableOffer, setDisableOffer] = useState(true)
   const negotiationOfferService = new NegotiationOfferService()

   useEffect(() => {
      generateOfferPayload(lastOffer)
      initSocket()
      handleDisableOffer(lastOffer?.offer)
   }, [])

   const initSocket = () => {
      socketRefNegotiation.current.on(Constant.socketEvents.RESPONSE_NEGO_OFFER, (resp) => {
         handleDisableOffer(resp)
         dispatch(
            negotiationOfferService.findLastOfferByNegotiationId(resp.negotiationId, (resp) => {
               generateOfferPayload(resp)
            }),
         )
      })
   }

   const generateOfferPayload = (_lastOffer) => {
      const arr = []
      let payload
      const sortedItems = [...negotiationItems].sort((a, b) => {
         const prA = a?.procurementItem?.prNumber ?? ""
         const prB = b?.procurementItem?.prNumber ?? ""
         if (prA !== prB) return prA.localeCompare(prB)
         const lineA = a?.procurementItem?.prLine ?? 0
         const lineB = b?.procurementItem?.prLine ?? 0
         if (lineA !== lineB) return lineA - lineB
         return (a?.procurementItem?.itemCode ?? "").localeCompare(b?.procurementItem?.itemCode ?? "")
      })
      for (const item of sortedItems) {
         payload = {}
         payload.negotiationItemId = item._id
         payload.itemCode = item.procurementItem.itemCode
         payload.itemName = item.procurementItem.itemName
         payload.qty = item.procurementItem.quantity
         payload.minCapableQty = item.procurementItem.minCapableQty
         payload.UOM = item.procurementItem.UOM
         payload.offer = item.lastPrice
         payload.capableQty = item.procurementItem.minCapableQty
         if (_lastOffer) {
            const { offerItems } = _lastOffer
            for (const offerItem of offerItems) {
               if (offerItem.negotiationItem.procurementItemId === item.procurementItemId) {
                  payload.offer = offerItem.offer
                  payload.capableQty = offerItem.capableQty
               }
            }
         }
         arr.push(payload)
      }

      setOfferPayloads(arr)
   }

   const handleChange = (idx, value, type) => {
      let _offers
      _offers = [...offerPayloads]

      if (type === "OFFER") {
         _offers[idx].offer = value
      } else if (type === "CAPABLE_QTY") {
         _offers[idx].capableQty = value
      }
      setOfferPayloads(_offers)
   }

   const sendOffer = () => {
      // UNIT_PRICE totals are the plain sum of unit offers, matching NegotiationOfferItemService.create.
      const total = offerPayloads.reduce((sum, item) => sum + Number(item.offer || 0), 0)
      if (vendorLastPrice && total >= vendorLastPrice) {
         toast.error("Offer price must be lower than vendor's last price")
         return
      }

      socketRefNegotiation.current.emit(Constant.socketEvents.MAKE_NEGO_OFFER_ITEMS, {
         negotiation: negotiation,
         negotiationOfferItems: offerPayloads,
         fromAccountId: fromAccountId,
         toAccountId: toAccountId,
         createdAt: new Date(Date.now()),
      })
   }

   const handleDisableOffer = (offer) => {
      setDisableOffer(true)
      if (offer) {
         if (offer.status === Constant.NEGOTIATION_STATUS_OFFER.NOT_DEAL) {
            if (offer.fromAccountId === accountId) {
               setDisableOffer(false)
            }
         } else if (offer.status !== Constant.NEGOTIATION_STATUS_OFFER.DEAL) {
            if (offer.toAccountId === accountId) {
               setDisableOffer(false)
            }
         }
      } else if (negotiation.fromAccountId === accountId) {
         setDisableOffer(false)
      }
   }

   return (
      <>
         {itemInitialPrice.length > 0 && (
            <>
               <MuiDataTable.CustomTable
                  stickyHeader={true}
                  containerStyles={{
                     maxHeight: "540px",
                     "&::-webkit-scrollbar": {
                        height: "8px",
                        width: "0",
                     },
                     "&::-webkit-scrollbar-thumb": {
                        background: "#C4C4C4",
                     },
                     scrollbarWidth: "thin",
                     scrollbarColor: "#C4C4C4",
                  }}
               >
                  <TableHead>
                     <TableRow>
                        <TableCell
                           rowSpan={2}
                           className="py-2"
                           size="small"
                           sx={{ background: "#D0D6E0", borderRight: "1px solid #ffffff" }}
                        >
                           <TableSortLabel
                              //    active={orderBy === "Item Name"}
                              //    direction={order}
                              onClick={(v) => handleRequestSort(v.target.outerText)}
                              IconComponent={ExpandLessIcon}
                           >
                              Item Name
                           </TableSortLabel>
                        </TableCell>

                        <TableCell
                           colSpan={3}
                           align="center"
                           className="py-2"
                           sx={{ borderBottom: "1px solid #ffffff" }}
                        >
                           Quantity
                        </TableCell>

                        <TableCell
                           rowSpan={2}
                           className="py-2"
                           align="right"
                           size="small"
                           sx={{ whiteSpace: "nowrap", background: "#D0D6E0", borderLeft: "1px solid #ffffff" }}
                        >
                           <TableSortLabel
                              //    active={orderBy === "Last Price"}
                              //    direction={order}
                              onClick={(v) => handleRequestSort(v.target.outerText)}
                              IconComponent={ExpandLessIcon}
                           >
                              Unit Price
                           </TableSortLabel>
                        </TableCell>
                     </TableRow>
                     <TableRow>
                        <TableCell size="small" sx={{ background: "#D0D6E0", borderBottom: "none" }}>
                           <TableSortLabel
                              //  active={orderBy === "Needed"}
                              //  direction={order}
                              onClick={(v) => handleRequestSort(v.target.outerText)}
                              IconComponent={ExpandLessIcon}
                           >
                              Needed
                           </TableSortLabel>
                        </TableCell>
                        <TableCell size="small" sx={{ background: "#D0D6E0", borderBottom: "none" }}>
                           <TableSortLabel
                              //  active={orderBy === "Minimum Capable"}
                              //  direction={order}
                              onClick={(v) => handleRequestSort(v.target.outerText)}
                              IconComponent={ExpandLessIcon}
                           >
                              Minimum
                           </TableSortLabel>
                        </TableCell>
                        <TableCell size="small" sx={{ background: "#D0D6E0", borderBottom: "none" }}>
                           <TableSortLabel
                              //  active={orderBy === "Vendor Capability"}
                              //  direction={order}
                              onClick={(v) => handleRequestSort(v.target.outerText)}
                              IconComponent={ExpandLessIcon}
                           >
                              Vendor
                           </TableSortLabel>
                        </TableCell>
                     </TableRow>
                  </TableHead>
                  <TableBody>
                     {offerPayloads?.map((item, index) => (
                        <TableRow
                           key={index}
                           sx={{
                              background: "#F3F5F4",
                              "&:hover": {
                                 background: "transparent",
                                 cursor: "pointer",
                              },
                           }}
                        >
                           <TableCell className="py-2" sx={{ minWidth: "120px" }}>
                              {item.itemName}
                           </TableCell>
                           <TableCell style={{ width: "102px" }} className="py-2">
                              {Formservice.QuantityFormatter(item.qty)}
                           </TableCell>
                           <TableCell className="py-2 " style={{ width: "106px" }}>
                              {Formservice.QuantityFormatter(item.minCapableQty)}
                           </TableCell>
                           <TableCell className="py-2 ">
                              <Form.Group className="mt-2">
                                 <Form.Control
                                    style={{ width: "100px" }}
                                    readOnly={
                                       disableOffer ||
                                       negotiation?.status === Constant.STATUS.NOT_STARTED ||
                                       negotiation?.status === Constant.STATUS.CANCELED ||
                                       negotiation?.status === Constant.STATUS.DONE
                                    }
                                    type="number"
                                    value={item.capableQty}
                                    onChange={(evt) => handleChange(index, evt.target.value, "CAPABLE_QTY")}
                                 ></Form.Control>
                              </Form.Group>
                           </TableCell>
                           <TableCell className="py-2" align="right" colSpan={2}>
                              <InputGroup className="mb-2">
                                 <CurrencyInput
                                    placeholder="0"
                                    className="form-control text-right"
                                    value={item.offer}
                                    currency={dataProcurement?.currency}
                                    onValueChange={(v) => handleChange(index, v, "OFFER")}
                                    // onComponentBlur={() => localStorage.setItem("autoReducer", autoReducer)}
                                    disabled={
                                       disableOffer ||
                                       negotiation?.status === Constant.STATUS.NOT_STARTED ||
                                       negotiation?.status === Constant.STATUS.CANCELED ||
                                       negotiation?.status === Constant.STATUS.DONE
                                    }
                                 />
                                 <InputGroupText>{dataProcurement?.currency}</InputGroupText>
                              </InputGroup>
                           </TableCell>
                        </TableRow>
                     ))}
                  </TableBody>
               </MuiDataTable.CustomTable>
               <Row className="mx-0 mt-3">
                  <Col className="d-flex justify-content-end px-0">
                     <Buttonaction
                        blueOcean
                        label="Send Offer"
                        disabled={
                           disableOffer ||
                           negotiation?.status === Constant.STATUS.NOT_STARTED ||
                           negotiation?.status === Constant.STATUS.CANCELED ||
                           negotiation?.status === Constant.STATUS.DONE
                        }
                        style={{ minWidth: "276px" }}
                        onClick={() => sendOffer()}
                     />
                  </Col>
               </Row>
            </>
         )}
      </>
   )
}

export default UnitPrice

const InputGroupText = styled(InputGroup.Text)`
   margin-left: -3px;
   font-size: 12px;
   z-index: 0;
`
